var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlutter = function SvgFlutter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#40D0FD",
    d: "m24.229 27.895 4.201-4.093h10.437l-9.245 9.246z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#41D0FD",
    d: "m11.134 25.156 5.249 5.374L38.866 7.859H28.43z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1FBCFD",
    d: "m18.97 33.099 5.324 5.245 5.328-5.297-5.393-5.152z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#095A9D",
    d: "m24.294 38.344 5.327-5.297 9.115 9.22H28.241z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E5199",
    d: "m24.294 38.344 4.964-1.651-1.673-1.622z"
  })));
};
export default SvgFlutter;